import axios from 'axios';

import { BACKEND_API_URI } from '@constants';

const LEAD_COLLECTION_API_URL = `${BACKEND_API_URI}/api/v1/sales/lead`;

export const createSalesLead = async (
  firstName,
  lastName,
  email,
  phoneNumber,
  campaignId,
  country,
  interestedVariants,
  optInConfirmation
) => {
  const { data } = await axios.post(LEAD_COLLECTION_API_URL, {
    firstName,
    lastName,
    email,
    campaignId,
    phoneNumber,
    countryForDelivery: country,
    receiveNotifications: optInConfirmation,
    vehiclesInterested: interestedVariants,
  });

  return data;
};
